// Node Module Imports
import React from 'react'

import { Link } from 'gatsby'
import styled from 'styled-components'

// Style Imports
import { above, fontSize, space } from '../../../style/design-system'
// other
import { studentInfo } from '../../../utils/static-data/studentInfo'
import ChevronBackgroundStroke from '../../elements/ChevronBackgroundStroke'

const BigNumberStatsHome = ({ className }) => (
  <div className={className}>
    <ChevronBackgroundStroke direction="east">
      <div className="container-fluid py-10">
        <div className="row">
          <div className="col-12 col-md-6 col-xl-4 offset-xl-2 text-center">
            <div className="established h3 blue d-md-none">Established, 1994.</div>
            <div className="big-num blue">{studentInfo.yearsInBusiness}</div>
            <div className="big-num-large-text blue upper">Years</div>
            <div className="big-num-small-text upper">in Healthcare Education</div>
          </div>
          <div className="col-12 col-md-6 col-xl-4 text-center">
            <div className="established h3 blue d-none d-md-block">Established, 1994.</div>
            <div className="established-sub">
              Ultimate Medical Academy is a nonprofit healthcare educational institution with a national presence. For over
              {' '}
              {studentInfo.yearsInBusiness}
              {' '}
              years, we’ve offered a comprehensive, accredited healthcare&nbsp;education.
            </div>

            <div className="sub-container">
              <div className="left-side">
                <div className="small-num blue">
                  {studentInfo.currentStudents.numberInThousands}
                  <span className="smaller">K</span>
                </div>
                <div className="small-num-subtext upper">Students</div>
              </div>
              <div className="right-side">
                <div className="small-num blue">
                  {Math.floor(studentInfo.grads.numberInThousands)}
                  <span className="smaller">K+</span>
                </div>
                <div className="small-num-subtext upper">Alumni</div>
              </div>
            </div>
            <div className="as-of-date">
              Approximately, as of
              {' '}
              {studentInfo.lastUpdatedDate}
            </div>

            <Link to="/about/" className="btn btn-outline-black d-md-none">About Us&nbsp;&gt;</Link>
          </div>
        </div>
      </div>
    </ChevronBackgroundStroke>
  </div>
)

export default styled(BigNumberStatsHome)`
  .container-fluid {
    padding: 4rem 3rem;
    ${above.md`
      padding: 4rem 2rem;
    `}
  }
  .big-num {
    font-size: 50vw;
    line-height: 1;
    ${above.md`
      font-size: 19rem;
      margin-top: -4rem;
    `}
    ${above.lg`
      font-size: 20rem;
    `}
  }
  .big-num-large-text {
    font-size: 16vw;
    line-height: .9;
    ${above.md`
      font-size: 6.5rem;
    `}
    ${above.lg`
      font-size: 7rem;
    `}
  }
  .big-num-small-text {
    font-size: 3.8vw;
    margin-top: ${space.d};
    ${above.md`
      font-size: 1.4rem;
    `}
  }
  .established {
    margin: ${space.g};
    font-size: 9vw;
    ${above.md`
      font-size: 6vw;
      margin: 0;
    `}
    ${above.lg`
      font-size: 4rem;
      margin: 0;
    `}
    ${above.xl`
      font-size: 3.3rem;
    `}
  }
  .established-sub {
    margin: ${space.f} 0;
    ${above.md`
      font-size: ${fontSize.f};
      margin: ${space.g} 0;
    `}
    ${above.lg`
      max-width: 91%;
      margin-left: auto;
      margin-right: auto;
    `}
  }
  .sub-container {
    border-top: 1px solid #000;
    padding: ${space.e} 0;
    margin: ${space.e} 0 0 0;
    display: flex;
    justify-content: center;
    .left-side {
      flex: 0 0 50%;
      border-right: 1px solid #000;
    }
    .right-side {
      flex: 0 0 50%;
    }
    .small-num {
      font-size: 3rem;
      line-height: .8;
      margin-bottom: ${space.d};
      ${above.sm`
        font-size: 5rem;
      `}
      ${above.md`
        font-size: 7.5vw;
      `}
      ${above.lg`
        font-size: 8vw;
      `}
      ${above.xl`
        font-size: 4.5rem;
      `}
      .smaller {
        font-size: .6em;
      }
    }
    .small-num-subtext {
      font-size: ${fontSize.f};
    }
  }
  .as-of-date {
    font-size: ${fontSize.d};
    margin-bottom: ${space.e};
  }
  .small-num-bottom-text {
    font-size: 4.7vw;
    ${above.sm`
      font-size: 4.4vw;
    `}
    ${above.md`
      font-size: 1.4rem;
    `}
  }
`
